import {
    TOGGLE_SELECTED, SET_READY, SHOW_INLINE_ERROR, RESET_ERROR
} from 'constants/actionTypes/googlePay';

function toggleSelect(isSelected) {
    return {
        type: TOGGLE_SELECTED,
        isSelected
    };
}

function showInlineError(errorMessage) {
    return {
        type: SHOW_INLINE_ERROR,
        error: {
            errorMessage
        }
    };
}

function resetError() {
    return {
        type: RESET_ERROR
    };
}

function setReady(readyStatus) {
    return {
        type: SET_READY,
        isReady: readyStatus
    };
}

export default {
    toggleSelect,
    setReady,
    showInlineError,
    resetError
};
